import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import LinkExpirado from '../views/LinkExpirado.vue'
import LinkInvalido from '../views/LinkInvalido.vue'
import Checkout from '../views/Checkout.vue'
import Index from '../views/Index.vue'

const routes = [
  { path: '/:uuid', name: 'index', component: Index, props: true },
  { path: '/:pathMatch(.*)*', component: Index }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
